module.exports = __webpack_public_path__ + "img/ptz-icon5.0b001d83.svg";